import { doGET, doPOST, doPUT, doDELETE } from '../../utils/HttpUtils';

export interface PerkHospital { _id: string; name: string; address?: string; city?: string; state?: string; pincode?: string; latitude?: number | null; longitude?: number | null; phone?: string; }
export interface PerkContact { name: string; phone?: string; email?: string; }
export interface HospitalPerk {
  _id: string;
  partnerId: PerkHospital | null;
  contactPerson?: PerkContact | null;
  images: string[];
  offers: { title: string; discountPercent: number; terms: string }[];
  eligibility: string;
  claimInstructions: string;
  validFrom: string;
  validUntil: string;
  isActive: boolean;
}
export type PerkInput = Omit<HospitalPerk, '_id' | 'partnerId'> & { partnerId?: string; hospitalName: string; hospitalLocation?: { address: string; city: string; state: string; pincode: string; latitude?: number | null; longitude?: number | null } };
async function unwrap(request: Promise<any>) {
  const response = await request;
  if (!(response?.status >= 200 && response?.status < 300)) {
    throw new Error(response?.message || 'Unable to save or load perks');
  }
  return response.data;
}
export const perkService = {
  list: (page: number, expired: '' | 'true' | 'false' = '') => unwrap(doGET(`/perks?page=${page}&limit=20${expired ? `&expired=${expired}` : ''}`)),
  save: (id: string | undefined, data: PerkInput) => unwrap(id ? doPUT(`/perks/${id}`, data) : doPOST('/perks', data)),
  remove: (id: string) => unwrap(doDELETE(`/perks/${id}`)),
};

export interface PerkClaim {
  _id: string;
  status: 'pending' | 'approved' | 'rejected';
  createdAt: string;
  notificationStatus: string;
  autoApproved?: boolean;
  confirmationStatus?: 'queued' | 'accepted' | 'unconfirmed' | 'failed';
  kylasTaskId?: number;
  reviewedBy?: string;
  reviewedAt?: string;
  reviewNote?: string;
  claimScope?: 'benefit' | 'branch_bundle';
  branchId?: string;
  claimCycle?: number;
  snapshot: {
    patient: { name?: string; accountName?: string; email?: string; phone?: string };
    hospital: PerkHospital;
    contactPerson?: PerkContact | null;
    offer?: { title: string; discountPercent: number; terms: string };
    benefits?: { title: string; benefitType: 'discount' | 'free'; discountPercent?: number; terms: string; validFrom?: string | null; validUntil?: string | null }[];
    requirement?: string;
    eligibility: string; claimInstructions: string; validFrom: string; validUntil: string;
  };
}
export const claimService = {
  list: (page: number, status: string) => unwrap(doGET(`/perks/claims?page=${page}&limit=20${status ? `&status=${status}` : ''}`)),
  get: (id: string) => unwrap(doGET(`/perks/claims/${id}`)),
  review: (id: string, status: string, reviewNote: string) => unwrap(doPUT(`/perks/claims/${id}/review`, { status, reviewNote })),
};
